import { OnboardingRepo } from "../onboarding.repo";
import * as _ from "lodash";
import { FileItems } from "../FileItems";

class loginClientController implements angular.IOnInit {
  public email: string;
  public otp: string;
  public isLoading = false;
  public showOtp = false;
  public error: string;
  public otpError = false;

  /** @ngInject */
  constructor(
    private onboardingRepo: OnboardingRepo,
    private $state: angular.ui.IStateService,
    private $stateParams: angular.ui.IStateParamsService,
    private notifyjs: any,
    private $window: angular.IWindowService,
    private $mdDialog: angular.material.IDialogService,
    private $rootScope: angular.IRootScopeService
  ) {}

  $onInit() {
    this.showOtp = false;
    // this.$window.localStorage.removeItem("user");
    // this.$window.localStorage.removeItem("user_email");
    // this.$window.localStorage.removeItem("user_signin");
  }

  sendOtp() {
    this.onboardingRepo.requestOtp(this.email).then((res) => {
      this.showOtp = true;
    });
  }

  login() {
    this.otpError = false;
    this.onboardingRepo.verifyOtp(this.email, this.otp).then((res) => {
      if (res !== "false") {
        this.$window.localStorage.setItem("user", res);
        this.$window.localStorage.setItem("user_email", this.email);
        this.$window.localStorage.setItem(
          "user_signin",
          new Date().toDateString() + " " + new Date().toTimeString()
        );
        this.$mdDialog.hide(true);
      } else {
        this.otpError = true;
      }
    });
  }
}

export const loginClient: angular.IComponentOptions = {
  template: require("./login.modal.html"),
  controller: loginClientController,
  bindings: {
    error: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/onboarding/client/login.modal.ts